<template>
  <div>
    <h2>Introduction 简介</h2>
    <p style="marginTop: 40px;">快速构建复杂的表单</p>
    <p>使用图层可以自定义你想要的功能，比如popover展示，逻辑校验等等</p>
    <p>展示内容与触发目标支持自定义模板</p>
    <p>支持多图层同时展示</p>
  </div>
</template>

<script>
export default {
  name: 'introduction'
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/introduction.vue